import React from 'react';
import { Navigate } from 'react-router-dom';
import { ROUTE_PATHS } from '@constants';
import { ACCOUNT_USER_ROLE } from '@enums';
import { useStore } from '@hooks';
import { observer } from 'mobx-react';

const AccountSettings = observer(() => {
    const store = useStore();
    const { me } = store.authStore;
    const isDeveloper = me?.permission?.role === ACCOUNT_USER_ROLE.DEVELOPER;

    return <Navigate to={isDeveloper ? ROUTE_PATHS.INTEGRATIONS_SETTINGS : ROUTE_PATHS.COMPANY_INFO} />;
});

export default AccountSettings;
